module.exports = __webpack_public_path__ + "static/media/planet1.e69aa28e.png";